import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  IconButton,
  Grid,
  Paper,
  TableContainer,
  InputAdornment,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CustomDatePickerMui from "../models/inputs/DateInput";
import moment from "moment";
import { ChevronRight } from "@material-ui/icons";
import CancelIcon from '@material-ui/icons/Cancel';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { presentFormatedData } from "../functionalComponents/dataFormatFunctions";

const ProposeCounterOfferDialog = (props) => {
  const { classes, open, onClose, row, handleUpdatePOLineDetails } = props;
  const [rowData, setRowData] = useState(row);

  const handleInputChange = (field, value) => {
    setRowData({
      ...rowData,
      [field]: field === "requestedDeliveryDate" || field === "committedDeliveryDate" ? value != null ? value.format('YYYY-MM-DDTHH:mm') : value : value
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      style={{ borderRadius: "1rem" }}
    >
      <DialogContent className={classes.dialogContent}>
        <Grid container justifyContent="flex-end">
          <Typography
            variant="body2"
            style={{
              fontSize: "1rem",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              onClose();
            }}
          >
            Close <CloseIcon style={{color:'#FF0000'}} fontSize="large" />
          </Typography>
        </Grid>
        <Typography
          style={{
            marginTop: "10px",
            fontWeight: "600",
            color: "black",
            fontSize: "2rem",
            margin: "1rem",
          }}
        >
          Propose counter offer
        </Typography>

        <TableContainer component={Paper} style={{ marginTop: 20 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Line</TableCell>
                <TableCell>Product Code/Description</TableCell>
                <TableCell>UoM</TableCell>
                <TableCell>Req. Qty</TableCell>
                <TableCell>Committed/Delivered Qty.</TableCell>
                <TableCell>Req. Date</TableCell>
                <TableCell>Committed/Delivery Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="left">
                  {rowData?.scheduleLineItemNumber}
                </TableCell>
                <TableCell align="left">
                {presentFormatedData(rowData.fgMaterialCode)}
                          {"/"}
                          <br />
                          {presentFormatedData(rowData.fgMaterialName)}
                </TableCell>
                <TableCell align="left">{rowData?.targetQuantityUOM}</TableCell>
                <TableCell align="left">
                  {localStorage.collabType !== "CMO" ? (
                    <TextField
                      variant="outlined"
                      type="number"
                      className={classes.textField}
                      value={rowData?.requestedQuantity}
                      onChange={(e) =>
                        handleInputChange(
                          "requestedQuantity",
                          Number(e.target.value)
                        )
                      }
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                                      {rowData?.requestedQuantity && rowData?.availableQtyDetails?.availableQty
                                        ? 
                              (rowData?.requestedQuantity <= rowData?.availableQtyDetails?.availableQty ? 
                              <CheckCircleIcon style={{ color: '#499F2A' }} fontSize="small" />
                              : rowData?.requestedQuantity <= rowData?.availableQtyDetails?.availableQtyWithRMPMPOs  
                                ? <RemoveCircleIcon style={{ color: '#FFCC00' }} fontSize="small" />
                                : <CancelIcon style={{ color:'#FF0000'}} fontSize="small" />
                                        )
                                        : rowData?.requestedQuantity && rowData?.availableQtyDetails?.availableQty === 0
                                          ? <CancelIcon style={{ color:'#FF0000'}} fontSize="small" />
                                          : null
                            }
                          </InputAdornment>
                        ),
                      }}
                    />
                  ) : (
                    rowData?.requestedQuantity || ""
                  )}
                </TableCell>
                <TableCell align="left">
                  {localStorage.collabType === "CMO" ? (
                    <TextField
                      variant="outlined"
                      type="number"
                      className={classes.textField}
                      value={rowData?.committedQuantity}
                      onChange={(e) =>
                        handleInputChange(
                          "committedQuantity",
                          Number(e.target.value)
                        )
                      }
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                                    {rowData?.committedQuantity && rowData?.availableQtyDetails?.availableQty  ? 
                                      (rowData?.committedQuantity <= rowData?.availableQtyDetails?.availableQty ? 
                                      <CheckCircleIcon style={{ color: '#499F2A' }} fontSize="small" />
                                      : rowData?.committedQuantity <= rowData?.availableQtyDetails?.availableQtyWithRMPMPOs  
                                        ? <RemoveCircleIcon style={{ color: '#FFCC00' }} fontSize="small" />
                                        : <CancelIcon style={{ color:'#FF0000'}} fontSize="small" />
                                        ) : rowData?.committedQuantity && rowData?.availableQtyDetails?.availableQty === 0
                                          ? <CancelIcon style={{ color:'#FF0000'}} fontSize="small" />
                                          : null
                                    }
                                  </InputAdornment>
                        ),
                      }}
                    />
                  ) : (
                    rowData?.committedQuantity || ""
                  )}
                </TableCell>
                <TableCell align="left">
                  {localStorage.collabType !== "CMO" ? (
                    <CustomDatePickerMui
                      value={rowData?.requestedDeliveryDate}
                      onChange={(date) =>
                        handleInputChange("requestedDeliveryDate", date)
                      }
                      minDate={new Date()}
                      notFullWidth
                    />
                  ) : rowData?.requestedDeliveryDate ? (
                    moment(rowData?.requestedDeliveryDate).format("DD-MMM-YYYY").toUpperCase()
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell align="left">
                  {localStorage.collabType === "CMO" ? (
                    <CustomDatePickerMui
                      value={rowData?.committedDeliveryDate}
                      onChange={(date) =>
                        handleInputChange("committedDeliveryDate", date)
                      }
                      minDate={new Date()}
                      notFullWidth
                    />
                  ) : rowData?.committedDeliveryDate ? (
                    moment(rowData?.committedDeliveryDate).format("DD-MMM-YYYY").toUpperCase()
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <DialogActions className={classes.dialogActions}>
          {actionButton(row,rowData, onClose, handleUpdatePOLineDetails)}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

const actionButton = ( originalRowData, rowData, onClose, handleUpdatePOLineDetails) => {
  let selectedLineitem = originalRowData;

  const isSameDate = (date1, date2) => {
    const d1 = new Date(date1).toISOString().split("T")[0]; // Extract YYYY-MM-DD
    const d2 = new Date(date2).toISOString().split("T")[0];
    return d1 === d2;
  };

  let changeInQty =
    localStorage.collabType !== "CMO"
      ? rowData.requestedQuantity ===
        selectedLineitem.requestedQuantity
        ? false
        : true
      : rowData.committedQuantity ===
        selectedLineitem.committedQuantity
      ? false
        : true;
  
  let qtyIsPresent = localStorage.collabType !== "CMO"
    ? rowData.requestedQuantity !== null
      ? true
      : false
    : rowData.committedQuantity !== null
      ? true
      : false

  let changeInDate =
    localStorage.collabType !== "CMO"
      ? rowData.requestedDeliveryDate &&
        selectedLineitem.requestedDeliveryDate
        ? isSameDate(
          rowData.requestedDeliveryDate,
            selectedLineitem.requestedDeliveryDate
          )
          ? false
          : true
        : rowData.requestedDeliveryDate
        ? true
        : false
      : rowData.committedDeliveryDate &&
        selectedLineitem.committedDeliveryDate
      ? isSameDate(
        rowData.committedDeliveryDate,
          selectedLineitem.committedDeliveryDate
        )
        ? false
        : true
      : rowData.committedDeliveryDate
      ? true
          : false;
  
  let dateIsPresent = localStorage.collabType !== "CMO"
    ? rowData.requestedDeliveryDate !== null
      ? true
      : false
    : rowData.committedDeliveryDate !== null
      ? true
      : false
  
  return (
    <Button
            variant="contained"
            color="primary"
            endIcon={<ChevronRight />}
            style={{
              borderRadius: "20px",
              textTransform: "none",
      }}
      disabled={(!changeInQty && !changeInDate) || !dateIsPresent || !qtyIsPresent}
            onClick={() => {
              handleUpdatePOLineDetails("poLineEditFlag",rowData,[])
              onClose();
            }}
          >
            Save changes
          </Button>
  )
}

export default ProposeCounterOfferDialog;
